import React from "react";
import { styled } from "@glitz/react";

interface ProductTitleProps {
  title: string;
}

const ProductTitleSlim: React.FC<ProductTitleProps> = ({ title }) => {
  return (
    <ProductTitleWrapper>
      <h5>{title}</h5>
    </ProductTitleWrapper>
  );
};
const ProductTitleWrapper = styled.div({
  textAlign: "center",
});

export default ProductTitleSlim;
